import { Component, Inject, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { TranslateService } from '@ngx-translate/core';
import { Patterns } from 'src/app/helpers/patterns';
import { AuthenticationService } from 'src/app/shared/services/authentication.service';
import { SwalService } from 'src/app/shared/services/swal.service';
import { UsersService } from 'src/app/shared/services/users.service';

export interface DialogData { }

@Component({
  selector: 'app-change-password',
  templateUrl: './change-password.component.html'
})
export class ChangePasswordComponent implements OnInit {

  formGroup!: FormGroup;
  loading = false;
  msgObj = { msg: '', type: '' };
  hideOldPassword = true;
  hidePassword = true;
  hideConfPassword = true;

  constructor(
    public dialogRef: MatDialogRef<ChangePasswordComponent>,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private formBuilder: FormBuilder,
    private service: UsersService,
    private authenticationService: AuthenticationService,
    public translate: TranslateService,
    private swalService: SwalService
  ) { }

  ngOnInit() {
    this.initForm();
  }

  submit() {
    if (this.formGroup.valid) {
      this.loading = true;
      const dataPass = {
        oldPassword: this.formGroup.controls['OldPassword'].value,
        newPassword: this.formGroup.controls['password'].value
      };
      this.service.changePassword(dataPass).subscribe(
        (data: any) => {
          this.loading = false;
          this.swalService.swalSuccess(this.translate.instant('auth.Password-updated-successfully'))
            .then((result: any) => {
              this.dialogRef.close(true);
              this.authenticationService.logout();
            });
        },
        (error: any) => {
          this.loading = false;
          this.handleErrors(error.detail);
        });
    }
  }

  initForm() {
    this.formGroup = this.formBuilder.group({
      OldPassword: ['', Validators.required],
      password: ['', [
        Validators.required,
        Validators.pattern(Patterns.password)
      ]],
      cPassword: ['', Validators.required]
    }, { validator: this.validateMatch });
  }

  validateMatch(group: FormGroup) {
    const pass = group.get('password')?.value;
    const confirmPass = group.get('cPassword')?.value;
    if (pass !== confirmPass) {
      group.get('cPassword')?.setErrors({ notMatch: true });
    } else {
      group.get('cPassword')?.setErrors(null);
    }
  }

  hasError(controlName: string, errorName: string) {
    return this.formGroup.controls[controlName].hasError(errorName);
  }

  handleErrors(errors: any) {
    errors = JSON.parse(errors);
    errors.ErrorDTO.forEach((error: any) => {
      if (error.ErrorCode === 'NotFound') {
        this.formGroup.controls[error.ErrorDetail].setErrors({ validOldPass: true });
      }
    });
  }
}
